import { Controller } from "@hotwired/stimulus"

// Marks a notification read when its link is followed (left or middle click): opening a
// notification is reading it, for every notifier — not only for the few whose show page
// clears its own rows. The row flips to read at once; the request is keepalive so it
// survives the navigation the click starts. It asks for the badges only, never a page
// refresh (a drawer link must keep its drawer), so the bell dot and the sidebar count
// follow when the page stays.
export default class extends Controller {
  static values = { url: String }

  mark(event) {
    if (event.type === "auxclick" && event.button !== 1) return
    if (this.element.dataset.unread !== "true") return

    this.element.dataset.unread = "false"
    fetch(`${this.urlValue}?view=badges`, {
      method: "PATCH",
      keepalive: true,
      credentials: "same-origin",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then((html) => window.Turbo?.renderStreamMessage(html))
      .catch(() => {
        this.element.dataset.unread = "true"
      })
  }
}
